import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { driverSchema } from 'components/modules/Insurance/components/Drivers/DriverCard.validation';
import { useMultipleSelect } from 'components/modules/Insurance/hooks/useMultipleSelect';
import { useValidation } from 'components/modules/Insurance/hooks/useValidation';
import { setDriverBatchState } from 'store/insuranceAnketa/actions';

import {
  SUBMIT_STORE_TRANSFORM,
  VALUES_STORE_FALLBACK,
  VALUES_STORE_MAP,
} from '../DriverCard.constants';

export const useSubmit = ({ id, values: valuesProp }) => {
  const valuesDependencies = Object.values(valuesProp);

  const dispatch = useDispatch();

  const selector = useCallback(
    () => {
      return valuesProp;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    valuesDependencies
  );

  const { values } = useMultipleSelect({
    fallback: VALUES_STORE_FALLBACK,
    map: VALUES_STORE_MAP,
    selector,
    transform: SUBMIT_STORE_TRANSFORM,
  });

  const { validate } = useValidation({ schema: driverSchema, values });

  const onSubmit = useCallback(async () => {
    const errors = await validate();
    const error = Boolean(Object.values(errors).length);

    if (error) {
      throw errors;
    }

    dispatch(setDriverBatchState({ id, values }));
  }, [validate]);

  return { onSubmit };
};
